// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2XyWq","productName":"Table_productName__2Uhzq"};